import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { MonthWiseModel } from 'src/app/models/department-app-verification.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first, shareReplay } from 'rxjs';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { DatePipe } from '@angular/common';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-challan-reconciliation-day-report',
  templateUrl: './challan-reconciliation-day-report.component.html',
  styleUrls: ['./challan-reconciliation-day-report.component.scss'],
  providers: [DatePipe]
})
export class ChallanReconciliationDayReportComponent implements OnInit {

  
  
  dayWise: any[];
  totalChallanDeposited:number;
  totalAmountDeposited:number;
  totalChallanRejected:number;
  totalAmountRejected:number;
  grandTotalChallanDeposited:number;
  grandTotalAmountDeposited:number;
  grandTotalChallanRejected:number;
  grandTotalAmountRejected:number;
  tempDayWise: any[];
  arrayIndex:number;
  appVerificationItems: MenuItem[];
  appVerificationModel: MonthWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];

  public userID: any;
  public value:any;
  public drilldownDetails:any;
  public challanName:any;
  public displayMaximizable:boolean;
  public status:any;

  public subjectSub:any;
  public selectedYear:any
  public loading: boolean = false;
  public subscriptions: any = [];


  constructor(private reportsService:ReportsService,
    private messageService:MessageService,
    private router: Router,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private datePipe: DatePipe,
    private cryptoJsService: CryptoJsService
    ) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    // this.loadData();
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
    
        this.loadData(this.selectedYear)
      }  
    );

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Challan_reconciliation_day_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Challan_reconciliation_day_report");
        }
      },
    ];
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear){
    // this.loader.start();
    this.loading = true;
    let sub = this.reportsService.getChallan_Reconciliation_day_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Challan Reconciliation Report (day Wise)', '', new Date(), 'Success');
            data.forEach(e=>{
              if(e.Date.length>0){
                e.Date_sort=new Date(e.Date);
                e.Date_filter=e.Date_sort.toString().substr(4,11)
                e.Months_sort=new Date (e.Months_sort)
              }
             })
            
             
            if (data?.length > 0) {
              this.dayWise = data;
              this.appVerificationModel = data;
              this.tempDayWise=data;
              this.arrayIndex=0;
              this.calculateGrandTotal();
            }
            else if(data?.length == 0) {
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.dayWise = [];
              this.appVerificationModel = [];
              this.tempDayWise = [];
              this.arrayIndex = 0;
              this.calculateGrandTotal();
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (Month Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });

        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Date" : d.Date,
          "Day": d.DayOfWeekName,
          "Challan Deposited": d.ChallanDeposited,
          "Amount Deposited": d.AmountDeposited,
          "Challan Rejected": d.ChallanRejected,
          "Amount Rejected": d.AmountRejected,

        }
      })     
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'Date', header: 'Date'},
      {field: 'DayOfWeekName', header: 'Day'},
      { field: 'ChallanDeposited', header: 'Challan Deposited' },
      { field: 'AmountDeposited', header: 'Amount Deposited' },
      { field: 'ChallanRejected', header: 'Challan Rejected' },
      { field: 'AmountRejected', header: 'Amount Rejected' },
    ];
    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  tableDataFunction(event: any) {
    this.tempDayWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalChallanDeposited=0;
        this.totalAmountDeposited=0;
        this.totalChallanRejected=0;
        this.totalAmountRejected=0;
        
          for(let i=this.arrayIndex ;this.tempDayWise.length>10?i<this.arrayIndex+10:i<this.tempDayWise.length;i++) {
            this.totalChallanDeposited +=this.tempDayWise[i].ChallanDeposited;
            this.totalAmountDeposited +=this.tempDayWise[i].AmountDeposited;
            this.totalChallanRejected +=this.tempDayWise[i].ChallanRejected;
            this.totalAmountRejected += this.tempDayWise[i].AmountRejected;
  
          }             
    }

  calculateGrandTotal(){
    this.grandTotalChallanDeposited=0;
    this.grandTotalAmountDeposited=0;
    this.grandTotalChallanRejected=0;
    this.grandTotalAmountRejected=0;
    for(let dayData of this.tempDayWise) {
      this.grandTotalChallanDeposited += dayData.ChallanDeposited;
      this.grandTotalAmountDeposited += dayData.AmountDeposited;
      this.grandTotalChallanRejected += dayData.ChallanRejected;
      this.grandTotalAmountRejected += dayData.AmountRejected;
  }
  }
  showMaximizableDialog_challan(actionType:any, value:any, count:any) {
    if(count <= 0){
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Record Not Available' });
      return;
    }

    if(actionType=='ChallanDeposited'){
      this.challanName='Challan Deposited'
      this.status='Approved'
    }
    if(actionType=='challanRejected'){
      this.challanName='challan Rejected'
      this.status='Rejected'
    }
        
    this.drilldownDetails={
      actionType: actionType,
      filterType:"Date",
      value: this.datePipe.transform(new Date(value), 'yyyy-MM-dd'),
      status:this.status,
      MIType:""
    }
    
    this.displayMaximizable = true;
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
}

}
